import { useState, useCallback } from 'react';

interface AlertState {
  type: 'success' | 'error' | 'warning' | 'info';
  title?: string;
  message: string;
  isVisible: boolean;
}

export const useAlert = () => {
  const [alert, setAlert] = useState<AlertState | null>(null);

  const showAlert = useCallback((
    type: 'success' | 'error' | 'warning' | 'info',
    message: string,
    title?: string
  ) => {
    setAlert({
      type,
      title,
      message,
      isVisible: true
    });
  }, []);

  const hideAlert = useCallback(() => {
    setAlert(null);
  }, []);

  const showSuccess = useCallback((message: string, title?: string) => {
    showAlert('success', message, title);
  }, [showAlert]);

  const showError = useCallback((message: string, title?: string) => {
    showAlert('error', message, title);
  }, [showAlert]);

  const showWarning = useCallback((message: string, title?: string) => {
    showAlert('warning', message, title);
  }, [showAlert]);

  const showInfo = useCallback((message: string, title?: string) => {
    showAlert('info', message, title);
  }, [showAlert]);

  return {
    alert,
    showAlert,
    hideAlert,
    showSuccess,
    showError,
    showWarning,
    showInfo
  };
};

export default useAlert;